import {PureComponent} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import {
  loadScript,
  removeScript,
} from './ScriptLoaderUtils';

class ScriptLoader extends PureComponent {

  static propTypes = {
    src: PropTypes.string,
    children: PropTypes.string,
    allScripts: PropTypes.array,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
  };

  static defaultProps = {
    onError: e => {
      console.log(`The script ${e.target.src} is not accessible`);
    },
    onLoad: Function.prototype,
  };

  constructor(props) {
    super(props);

    this.script = null;
  }

  componentDidMount() {
    const {
      onLoad,
      onError,
      children,
      preload,
      allScripts,
      ...otherProps
    } = this.props;

    if (!allScripts) {
      this.script = loadScript(otherProps, children, onLoad, onError);
    }

    if (allScripts) {
      this.loadClientScript();
    }
  }

  componentWillUnmount() {
    removeScript(this.script)
  }

  // @todo nested loading(for client.js) logic should move VoltranFragment.js - loadClientScript, loadAllScripts and loadScriptSrc functions
  loadClientScript = () => {
    const {
      src,
      allScripts,
    } = this.props;

    if (src) {
      const clientScript = src.indexOf('client') > -1 ? src : '';

      if (clientScript) {
        this.loadScriptSrc(clientScript, this.loadAllScripts(allScripts));
      }

      //TODO: VUEJS PROJECT CLIENT SIDE EXPORT FILE
      if(src?.includes?.('asktoseller')) {
        this.loadScriptSrc(src, this.loadAllScripts(allScripts));
      }
    }
  }

  loadAllScripts = (res) => {
    res.map((script) => { //eslint-disable-line
      if (script.src && script.src.indexOf('/client-') < 0) {
        setTimeout(() => {
          this.loadScriptSrc(script.src);
        }, 0);
      }
    });
  };

  loadScriptSrc = (scriptUrl, callback) => {
    const {
      allScripts,
      onLoad,
      onError,
      ...otherProps
    } = this.props;


    loadScript({
      ...otherProps,
      src: scriptUrl,
      defer: true,
    }, null,
    function() {
      if (callback) {
        callback();
      }
    },
    onError
    );
  }

  render() {
    return null;
  }
}

export default ScriptLoader;
